import { Box, FormHelperText, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TkBorder from "../../components/atoms/TkBorder";
import TkButton from "../../components/atoms/TkButton";
import TkCheckbox from "../../components/atoms/TkCheckbox";
import TkDialog from "../../components/atoms/TkDialog";
import { TkRadioGroup } from "../../components/atoms/TkRadioGroup";
import TkSelectForm from "../../components/atoms/TkSelectForm";
import "./_style.scss";
import dayjs from "dayjs";
import {
  DestinationType,
  DisplaySwitching,
  FormOutputStatus,
  HoujinnType,
  OutputFlg,
  Prefectures,
  ProcessType,
} from "../../assets/data/Constants";
import TkCorporateSearchModal from "../../components/molecules/TkCorporateSearchModal";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkFacilitySearchModal from "../../components/molecules/TkFacilitySearchModal";
import TkResigneeSearchModal from "../../components/molecules/TkResigneeSearchModal";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_REP002_Request } from "../../type/apiType";
import {
  httpAPI_CON001,
  httpAPI_FAC038,
  httpAPI_REP001,
  httpAPI_REP002,
  httpAPI_REP003,
  httpAPI_RET019,
} from "./api/request";
import {
  dataDownload,
  definitiveStatisticalOutput,
  destinationRadioList,
  headList,
  houjinnRadioList,
  printDataOutput,
  radioList,
  selectStaus,
  yearOutput,
} from "./parts";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { TkGetCode } from "../../utils/TkGetCode";

/**
 * SCRW170001 データダウンロード
 * @return SCRW170001 データダウンロード
 */
const SCRW170001 = () => {
  const navigate = useNavigate();

  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  const [open, setOpen] = useState(false);
  // 処理選択必須エラー
  const [errorMsg, setErrorMsg] = useState("");
  // ファイル選択必須エラー
  const [fileErrorMsg, setFileErrorMsg] = useState("");
  //宛先（抽出条件）ラジオ必須エラー
  const [destinationErrorMsg, setDestinationErrorMsg] = useState("");
  //法人宛詳細条件（抽出条件）
  const [houjinnErrorMsg, setHoujinnErrorMsg] = useState("");
  // 抽出条件検索必須エラー
  const [searchItemErrorMsg, setSearchItemErrorMsg] = useState("");
  // ファイル同時選択のエラー
  const [selectedFileErrorMsg, setSelectedFileErrorMsg] = useState("");
  // 法人検索
  const [openSuccess, setOpenSuccess] = useState<boolean>(false);
  const [corpList, setCorpList] = useState<any>([]);
  const [selectedCorp, setSelectedCorp] = useState<any[]>();
  // 施設検索
  const [openSuccessFacility, setOpenSuccessFacility] =
    useState<boolean>(false);
  const [facilityList, setFacilityList] = useState<any>([]);
  const [selectedFacility, setSelectedFacility] = useState<any[]>();
  // 退職者検索
  const [openRetireeSearch, setOpenRetireeSearch] = useState<boolean>(false);
  const [retireeList, setRetireeList] = useState<any>([]);
  const [selectedRetiree, setSelectedRetiree] = useState<any[]>();

  const [infoBodyList, setInfoBodyList] = useState<any[]>([]);
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [selectedValuesTemp, setSelectedValuesTemp] = useState<string[]>([]);
  const [selectGroupValue, setSelectGroupValue] = useState<string>();
  const [selectedValue, setSelectedValue] = useState<string>();
  const [houjinnSelect, setHoujinnSelect] = useState<string>();
  const [res, setRes] = useState<any>([]);
  const [downloadList, setDownloadList] = useState<any[]>();
  const [displaySwitching, setDisplaySwitching] = useState<string>();
  const printLabel = printDataOutput[printDataOutput.length - 1].label;

  // 初期表示
  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 出力結果一覧参照API
  const handleInit = async () => {
    try {
      const res = await httpAPI_REP001();
      if (res.resultCd === "I0000") {
        const bodyList = formOutputResultList(res.formOutputResultList);
        setInfoBodyList(bodyList);
        setRes(res.formOutputResultList);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // テーブルデータ整形
  const formOutputResultList = (OutputResultList: any) => {
    const bodyList = OutputResultList?.map((item: any) => {
      let childrenValue = "";
      let status = item.formOutputStatus ?? item.outputStatus;
      switch (status) {
        case FormOutputStatus["処理待ち"]:
        case FormOutputStatus["出力中"]:
        case FormOutputStatus["出力完了"]:
          childrenValue = "なし";
          break;
        case FormOutputStatus["エラー"]:
          childrenValue = "エラー";
          break;
        case FormOutputStatus["再出力待ち"]:
          childrenValue = "再出力待ち";
          break;
        default:
      }

      const disabledFlag =
        status !== FormOutputStatus["出力完了"] || +item.outpuKindFlg === 1;
      const makefileName = () => {
        return item.fileName;
      };

      const outputDate = item.outputDate ?? item.endDate;
      return [
        {
          children: childrenValue,
          disabledCheckBox: disabledFlag,
          forSort: childrenValue,
        },
        {
          children: outputDate && dayjs(outputDate).format("YYYY/MM/DD HH:mm"),
          forSort: outputDate,
          align: "center",
        },
        {
          children: makefileName(),
          forSort: item.fileName,
        },
        {
          children: item.createUser,
          forSort: item.createUser,
        },
      ];
    });
    return bodyList ?? [];
  };

  const handleOpen = () => {
    if (!selectGroupValue) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0044E",
      });
      return;
    }
    setState({
      ...state,
      errorMsgId: "",
    });
    setOpen(true);
  };

  const handleCheckboxChange = (label: any) => {
    clearAll2();
    if (selectedValuesTemp.includes(label)) {
      setSelectedValuesTemp(
        selectedValuesTemp.filter((item) => item !== label)
      );
    } else {
      setSelectedValuesTemp([...selectedValuesTemp, label]);
    }
  };

  const handleSelectChange = (value: any) => {
    clearAll1();
    setSelectGroupValue(value);
    if (!value) {
      setErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
    } else {
      setErrorMsg("");
    }
  };

  const handleSelect2Change = (e: any) => {
    clearAll3();
    setSearchItemErrorMsg("");
    if (e && e.target && e.target.value) {
      let selectValue = e.target.value;
      setSelectedValue(selectValue);
      setDestinationErrorMsg("");
    } else {
      setSelectedValue(undefined);
      setDestinationErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
    }
  };

  const handleSelect3Change = (e: any) => {
    setSearchItemErrorMsg("");
    if (e && e.target && e.target.value) {
      let selectValue = e.target.value;
      setHoujinnSelect(selectValue);
      setHoujinnErrorMsg("");
    } else {
      setHoujinnSelect(undefined);
      setHoujinnErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
    }
  };

  const handleSelectClean = () => {
    setSelectedValues([]);
    setSelectedValuesTemp([]);
    if (selectGroupValue === "4") {
      // 法人クリア
      selectedCorp?.length !== 0 && setSelectedCorp([]);
      // 施設検索クリア
      selectedFacility?.length !== 0 && setSelectedFacility([]);
      // 退職者検索クリア
      selectedRetiree?.length !== 0 && setSelectedRetiree([]);
    }
  };

  useEffect(() => {
    if (selectedValuesTemp.length > 0) {
      setFileErrorMsg("");
    }
  }, [selectedValuesTemp]);

  useEffect(() => {
    if (
      (selectedCorp && selectedCorp.length > 0) ||
      (selectedFacility && selectedFacility.length > 0) ||
      (selectedRetiree && selectedRetiree.length > 0)
    ) {
      setSearchItemErrorMsg("");
    }
  }, [selectedCorp, selectedFacility, selectedRetiree]);

  // 「出力実行」ボタンのイベント
  const handleFormOutput = async () => {
    // 必須チェック
    if (
      !selectGroupValue || //処理タイプ
      selectedValuesTemp.length < 1 //ファイル選択
    ) {
      !selectGroupValue &&
        !errorMsg &&
        setErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
      selectedValuesTemp.length < 1 &&
        !fileErrorMsg &&
        setFileErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));

      return;
    }

    if (
      (selectedValuesTemp.includes(printLabel) && !selectedValue) ||
      (selectedValuesTemp.includes(printLabel) &&
        selectedValue === DestinationType["法人宛"] &&
        !houjinnSelect) ||
      (selectedValuesTemp.includes(printLabel) &&
        selectedValue === DestinationType["法人宛"] &&
        houjinnSelect === "4" &&
        !selectedCorp) ||
      (selectedValuesTemp.includes(printLabel) &&
        selectedValue === DestinationType["施設宛"] &&
        !selectedFacility) ||
      (selectedValuesTemp.includes(printLabel) &&
        selectedValue === DestinationType["退職者宛"] &&
        !selectedRetiree)
    ) {
      // 宛名印刷を選択している場合、抽出条件の必須確認
      !selectedValue &&
        !destinationErrorMsg &&
        setDestinationErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
      !houjinnSelect &&
        !houjinnErrorMsg &&
        setHoujinnErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
      switch (selectedValue) {
        case DestinationType["法人宛"]:
          if (houjinnSelect === HoujinnType["法人を指定"]) {
            // 法人を指定を選択の場合
            !selectedCorp &&
              setSearchItemErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
          }
          break;
        case DestinationType["施設宛"]:
          // 施設宛選択時
          !selectedFacility &&
            setSearchItemErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
          break;
        case DestinationType["退職者宛"]:
          // 退職者宛選択時
          !selectedRetiree &&
            setSearchItemErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
          break;
        default:
          break;
      }
      return;
    }

    setDisplaySwitching(undefined);
    setDownloadList(undefined);
    try {
      const res = await httpAPI_REP002(makeHttpObj());
      if (res.resultCd === "I0000") {
        let formList: any[] = res.formOutputResultList ?? [];
        const bodyList = formOutputResultList(formList);
        setInfoBodyList(bodyList);
        setRes(res.formOutputResultList);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const makeHttpObj = (): IAPI_REP002_Request => {
    const makeAddressList = (): IAPI_REP002_Request["addressList"] => {
      let returnObj: IAPI_REP002_Request["addressList"] = [];
      if (houjinnSelect === HoujinnType["法人を指定"]) {
        returnObj = selectedCorp?.map((item) => ({
          contractorNo: item.contractorNo,
        }));
      } else if (selectedValue === DestinationType["施設宛"]) {
        returnObj = selectedFacility?.map((item) => ({
          contractorNo: item.contractorNumber,
          facilityNo: item.facilityNumber,
        }));
      } else if (selectedValue === DestinationType["退職者宛"]) {
        returnObj = selectedRetiree?.map((item) => ({
          contractorNo: item.contractorNo,
          staffNo: item.staffNo,
        }));
      }

      return returnObj;
    };

    const reqObj: IAPI_REP002_Request = {
      processType: selectGroupValue,
      fileSelectList: makeSelectedValuesObj(),
      addressSelect: selectedValue, //宛先（抽出条件）
      addressDetailSelect: houjinnSelect, //法人宛詳細条件（抽出条件）
      addressList: makeAddressList(),
    };

    return reqObj;
  };

  const makeSelectedValuesObj = () => {
    let returnObj: any = [];
    if (selectGroupValue !== ProcessType["印刷データ出力"]) {
      const totalFiles = [
        ...yearOutput,
        ...definitiveStatisticalOutput,
        ...dataDownload,
      ];
      returnObj = totalFiles
        .filter((i: any) => selectedValues.includes(i.label))
        ?.map((iii: any) => {
          return { formKbn: iii.formKbn, formClass: iii.value };
        });
    } else {
      returnObj = [
        {
          externalInterfaceList: printDataOutput
            .filter((i: any) => selectedValues.includes(i.label))
            ?.map((iii: any) => {
              return {
                externalInterface: iii.value,
              };
            }),
        },
      ];
    }
    return returnObj;
  };

  const OhandleutputConditionClear = () => {
    setSelectGroupValue(undefined);
    setSearchItemErrorMsg("");
    clearAll1();
  };

  const handleCallApi = async (data: any) => {
    // 契約者一覧参照API呼び出し
    try {
      const res = await httpAPI_CON001(data);

      if (res.resultCd === "I0000") {
        // 初期表示
        const corList = res.contractorList!.map((contractor) => ({
          ...contractor,
          prefectureCd: TkGetCode(Prefectures, contractor.prefectureCd),
        }));

        setCorpList(corList);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setOpenSuccess(false);
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSave = (data: any) => {
    if (!data) return;

    setOpenSuccess(false);
    setSelectedCorp(data);
  };

  const handleCallApiFacility = async (data: any) => {
    // 施設一覧取得API呼び出し
    try {
      const res = await httpAPI_FAC038(data);

      if (res.resultCd === "I0000") {
        // 初期表示
        const facilityList = res.facilityList!;
        setFacilityList(
          facilityList.map((item: any) => {
            return {
              contractorNumber: item.contractorNo,
              contractorName: item.corpName,
              companyAddress:
                (item.prefectureName ?? "") +
                (item.addressCity ?? "") +
                (item.addressOthers ?? ""),
              facilityNumber: item.facilityNo,
              facilityName: item.facilityName,
            };
          })
        );
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setOpenSuccessFacility(false);
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSaveFacility = (data: any) => {
    if (!data) return;

    setOpenSuccessFacility(false);
    setSelectedFacility(data);
  };

  const handleCallApiRetiree = async (data: any) => {
    // 退職者一覧取得API呼び出し
    try {
      const res = await httpAPI_RET019(data);

      if (res.resultCd === "I0000") {
        // 初期表示
        const retireeList = res.fileList!;
        setRetireeList(retireeList);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setOpenRetireeSearch(false);
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSaveRetiree = (data: any) => {
    if (!data) return;

    setOpenRetireeSearch(false);
    setSelectedRetiree(data);
  };

  const handleDisplaySwitching = (e: any) => {
    if (e.target?.value === undefined) return;
    const displayFlag = e.target.value;
    setDisplaySwitching(displayFlag);
    if (displayFlag === DisplaySwitching["ダウンロード未実行"]) {
      const result = resultFilter(res);
      setInfoBodyList(formOutputResultList(result));
    } else {
      setInfoBodyList(formOutputResultList(res));
    }
  };

  const resultFilter = (res: any) => {
    return res && res.length > 0
      ? res.filter((item: any) => item.outputFlg === OutputFlg["未出力"])
      : [];
  };

  const clearAll1 = () => {
    setState({
      ...state,
      errorMsgId: "",
    });
    setSelectedValuesTemp([]);
    setSelectedValues([]);
    clearAll2();
  };

  const clearAll2 = () => {
    setSelectedValue(undefined);
    clearAll3();
  };

  const clearAll3 = () => {
    setSelectedCorp(undefined);
    setHoujinnSelect(undefined);
    setSelectedFacility(undefined);
    setSelectedRetiree(undefined);
  };

  const downloadFile = (fileName: string, dataStr: string) => {
    const eleLink = document.createElement("a");
    eleLink.download = fileName;
    eleLink.style.display = "none";
    eleLink.href = dataStr;
    document.body.appendChild(eleLink);
    eleLink.click();
    document.body.removeChild(eleLink);
  };

  // 選択
  const handleSelectTable = (indexArr: number[]) => {
    if (res) {
      let realData =
        displaySwitching === DisplaySwitching["ダウンロード未実行"]
          ? resultFilter(res)
          : res;

      const selectedList = realData?.filter((item: any, index: number) =>
        indexArr.includes(index)
      );

      setDownloadList(selectedList);
    } else {
      setDownloadList([]);
    }
  };

  const handleDownloadData = async () => {
    if (!downloadList || downloadList.length === 0) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0044E",
      });
      return;
    } else {
      setState({
        ...state,
        errorMsgId: "",
      });
    }

    const fileSelectList: any = downloadList.map((item: any) => {
      return {
        requestId: item.requestId,
        externalInterfaceFlg: item.externalInterfaceFlg,
      };
    });
    // データダウンロードユーザ更新APIを呼び出す。
    try {
      const res = await httpAPI_REP003({ fileSelectList });

      if (res.resultCd === "I0000") {
        const bodyList = formOutputResultList(res.formOutputResultList);
        setInfoBodyList(bodyList);
        setRes(res.formOutputResultList);
        setState({
          ...state,
          errorMsgId: "",
        });
        if (res.formOutputResultList && res.formOutputResultList?.length > 0) {
          res.formOutputResultList.forEach((formOutputResult) => {
            const resFileName = formOutputResult?.fileName;
            const resFileBase64 = formOutputResult?.fileBase64;
            if (resFileName && resFileBase64) {
              downloadFile(resFileName, resFileBase64);
            }
          });
        }

        setDisplaySwitching(undefined);
        handleInit();
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleFormUpdate = async () => {
    setDisplaySwitching(undefined);
    setDownloadList(undefined);
    handleInit();
  };

  // 選択して閉じる
  const handleSelectAndClose = () => {
    // (ⅰ)「宛名印刷」とその他のファイルが同時に選択されいる場合。
    // メッセージを表示し、処理を中断
    if (
      selectedValuesTemp.length > 1 &&
      selectedValuesTemp.includes(printLabel)
    ) {
      selectedFileErrorMsg === "" &&
        setSelectedFileErrorMsg(TkPropertyMessageGet("TKMSG_SCR0096E"));
      return;
    }
    setSelectedFileErrorMsg("");
    setSelectedValues(selectedValuesTemp);
    setOpen(false);
  };

  useEffect(() => {
    //ファイル選択とモーダルの選択を合わせる
    if (!open) {
      setSelectedValuesTemp(selectedValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Box data-testid="SCRW170001PageForTest" className="SCRW170001">
      <TkBorder>
        <Typography className="title">出力条件</Typography>
        <Box className="inputGroup">
          <Typography className="title">処理タイプ</Typography>
          <TkBorder className="radioGroup">
            <TkRadioGroup
              row={true}
              radioPropsList={radioList}
              wantToSetValue={selectGroupValue}
              onGetValue={handleSelectChange}
              errorMessage={errorMsg}
            />
          </TkBorder>
        </Box>

        <Box className="inputGroup">
          <Typography className="title">ファイル選択</Typography>
          <Box className="fileSelect">
            <TkBorder>
              {selectedValues.map((value: string, index: number) => (
                <Box key={index}>{value}</Box>
              ))}
              {!!fileErrorMsg && (
                <Box>
                  <FormHelperText error>{fileErrorMsg}</FormHelperText>
                </Box>
              )}
            </TkBorder>
            <Box className="fileButtonGroup">
              <TkButton onClick={handleOpen}>選択</TkButton>
              <TkButton onClick={handleSelectClean}>選択削除</TkButton>
            </Box>
          </Box>
        </Box>

        <Box className="inputGroup">
          <Typography className="title">抽出条件</Typography>
          <Box>
            {selectedValues.includes(printLabel) &&
              selectGroupValue === ProcessType["印刷データ出力"] && (
                <TkRadioGroup
                  value={destinationRadioList[0].value}
                  radioPropsList={destinationRadioList}
                  onChange={(e) => handleSelect2Change(e)}
                  errorMessage={destinationErrorMsg}
                ></TkRadioGroup>
              )}

            {selectedValues.includes(printLabel) &&
              selectedValue === DestinationType["法人宛"] &&
              selectGroupValue === ProcessType["印刷データ出力"] && (
                <TkRadioGroup
                  value={houjinnRadioList[0].value}
                  radioPropsList={houjinnRadioList}
                  onChange={(e) => handleSelect3Change(e)}
                  errorMessage={houjinnErrorMsg}
                />
              )}

            {selectedValues.includes(printLabel) &&
              selectedValue === DestinationType["法人宛"] &&
              houjinnSelect === HoujinnType["法人を指定"] && (
                <Box className="searchItem">
                  <Box className="displayItem">
                    {selectedCorp &&
                      selectedCorp.map((item, index) => (
                        <Typography key={index}>
                          {`${item.contractorNo}:${item.corpName}`}
                        </Typography>
                      ))}
                  </Box>
                  <TkButton onClick={() => setOpenSuccess(true)}>
                    法人検索
                  </TkButton>
                </Box>
              )}
            {selectedValues.includes(printLabel) &&
              selectedValue === DestinationType["施設宛"] && (
                <Box className="searchItem">
                  <Box className="displayItem">
                    {selectedFacility &&
                      selectedFacility.map((item, index) => (
                        <Typography key={index}>
                          {`${item.facilityNumber}:${item.facilityName}`}
                        </Typography>
                      ))}
                  </Box>
                  <TkButton onClick={() => setOpenSuccessFacility(true)}>
                    施設検索
                  </TkButton>
                </Box>
              )}
            {selectedValues.includes(printLabel) &&
              selectedValue === DestinationType["退職者宛"] && (
                <Box className="searchItem">
                  <Box className="displayItem">
                    {selectedRetiree &&
                      selectedRetiree.map((item, index) => (
                        <Typography key={index}>
                          {`${item.staffNo}:${item.retirementStaffName}`}
                        </Typography>
                      ))}
                  </Box>
                  <TkButton onClick={() => setOpenRetireeSearch(true)}>
                    退職者検索
                  </TkButton>
                </Box>
              )}
            {!!searchItemErrorMsg && (
              <Box>
                <FormHelperText error>{searchItemErrorMsg}</FormHelperText>
              </Box>
            )}
          </Box>
        </Box>

        <Box className="border" />
        <Box className="buttonGroup">
          <TkButton onClick={handleFormOutput}>出力実行</TkButton>
          <TkButton onClick={OhandleutputConditionClear}>
            出力条件クリア
          </TkButton>
        </Box>
      </TkBorder>

      <Box style={{ height: "20px" }}></Box>
      <TkBorder>
        <Typography>出力結果</Typography>
        <Box className="resultForm">
          <TkSelectForm
            label="表示切替"
            selectPropsList={selectStaus}
            wantToSetValue={displaySwitching}
            onChange={handleDisplaySwitching}
          ></TkSelectForm>
          <TkButton onClick={handleDownloadData}>
            データダウンロード実行
          </TkButton>
          <TkButton onClick={handleFormUpdate}>更新</TkButton>
        </Box>
        <TkDataTable
          headList={headList}
          bodyList={infoBodyList}
          checkSection={true}
          checkboxIndex={1}
          onCheckSectionWidth={(indexArr: any) => handleSelectTable(indexArr)}
        />
      </TkBorder>

      <TkDialog
        open={open}
        okText="選択して閉じる"
        onSave={handleSelectAndClose}
        onCancel={() => {
          setSelectedValuesTemp([]);
          setOpen(false);
        }}
      >
        <Box className="SCRW170001Dialog">
          {selectGroupValue === ProcessType["年度末統計出力"] &&
            yearOutput.map((item, index) => (
              <TkCheckbox
                key={index}
                label={item.label}
                checked={selectedValuesTemp.includes(item.label)}
                onChange={() => handleCheckboxChange(item.label)}
              />
            ))}
          {selectGroupValue === ProcessType["確定統計出力"] &&
            definitiveStatisticalOutput.map((item, index) => (
              <TkCheckbox
                key={index}
                label={item.label}
                checked={selectedValuesTemp.includes(item.label)}
                onChange={() => handleCheckboxChange(item.label)}
              />
            ))}
          {selectGroupValue === ProcessType["データダウンロード"] &&
            dataDownload.map((item, index) => (
              <TkCheckbox
                key={index}
                label={item.label}
                checked={selectedValuesTemp.includes(item.label)}
                onChange={() => handleCheckboxChange(item.label)}
              />
            ))}
          {selectGroupValue === ProcessType["印刷データ出力"] &&
            printDataOutput.map((item, index) => (
              <TkCheckbox
                key={index}
                label={item.label}
                checked={selectedValuesTemp.includes(item.label)}
                onChange={() => handleCheckboxChange(item.label)}
                errorMessage={
                  printDataOutput.length - 1 === index
                    ? selectedFileErrorMsg
                    : ""
                }
              />
            ))}
        </Box>
      </TkDialog>

      <TkCorporateSearchModal
        open={openSuccess}
        useCheck={true}
        listData={corpList}
        onClose={() => setOpenSuccess(false)}
        onChangeSearchData={handleCallApi}
        onSave={handleSave}
      />

      <TkFacilitySearchModal
        open={openSuccessFacility}
        useCheck={true}
        listData={facilityList}
        onClose={() => setOpenSuccessFacility(false)}
        onChangeSearchData={handleCallApiFacility}
        onSave={handleSaveFacility}
      />

      <TkResigneeSearchModal
        open={openRetireeSearch}
        useCheck={true}
        listData={retireeList}
        onChangeSearchData={handleCallApiRetiree}
        onClose={() => setOpenRetireeSearch(false)}
        onSave={handleSaveRetiree}
      />
    </Box>
  );
};

export default SCRW170001;
